import React, { useState } from "react";
import config from "../config";
import { userService } from '../container';
import toast, { Toaster } from 'react-hot-toast';
const { useNavigate } = require("react-router-dom");

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const loginWithGoogle = () => {
    window.location.href = `${config.apiUrl}/api/v1/users/login/google`;
  };

  const loginWithEmailAndPassword = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await userService.login(email, password);

      navigate('/');
    } catch (err) {
      console.error(err);
      toast.error('Credenciales incorrectas.');
    }

    setLoading(false);
  };

  return (
    <>
      <Toaster />
      <div id="login">

        <div className="left">
          <div>
            <picture>
              <source srcSet="/assets/media/logo.png" media="(max-width: 430px)" />
              <img src="/assets/media/logo-white.png" width={40} height={40} />
            </picture>
          </div>
        </div>

        <div className="right">
          <div className="oauth-login">
            <h1 className="t-heading-xl-cms">Hola de nuevo! 👋</h1>

            <p className="t-heading-m">Ingresa con tu correo de Gmail.</p>

            <button onClick={loginWithGoogle}>
              <img src="/assets/ds/icons/google.svg" />
              Ingresar con Google
            </button>
          </div>

          <div className="email-login">
            <p className="t-heading-m">Ingresa con email y contraseña</p>

            <form className="email-login-form" onSubmit={loginWithEmailAndPassword}>
              <div className="form-group">
                <label htmlFor="email">Correo electrónico</label>
                <input
                  className="input t-body-m"
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Contraseña</label>
                <input
                  className="input t-body-m"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div className="form-group">
                <button
                  type="submit"
                  disabled={!email || !password || loading}
                >
                  {loading ? 'Cargando...' : 'Ingresar'}
                </button>
              </div>
            </form>
          </div>

          <p className="t-body-s">© 2023 Alivia</p>
        </div>
      </div>
    </>
  )
}
